import { Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const LegendHint = () => {
  const { t } = useTenantTranslation();
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ display: "block", mt: 0.5, textAlign: "center" }}
    >
      {t("legendTraceHint")}
    </Typography>
  );
};
